import { connect } from "react-redux";
import Content from "../components/Content";

const mapStateToProps = (state, {id}) => ({
    items: state.get("images"),
    type: 'images',
    selected: 'sight'
});

export default connect(mapStateToProps)(Content);


// WEBPACK FOOTER //
// ./src/containers/Sight.js